<script>
export let has_products;
export let plan;
export let metadata;
</script>
<header-tag-promo class="header-promo {$$props.class}">
    {#if has_products === false}
        {#if plan.is_recommended === "Recomendado" || plan.is_recommended === "recommended"}
            <h4 class="defaultItem header-title is-flex is-gap-10 py-alt-1 fw500 is-align-items-center is-justify-content-center {plan.has_discount}  has-text-centered">
                <span>
                    <i class="iconfont x-outline-receipt-disscount font-restricted-size-24"></i>
                </span>
                <span>
                    {metadata.lang.defaultItem}
                </span>
            </h4>
        {/if}    
    {/if}
    {#if has_products}
        <h4 class="{plan.has_discount} {plan.type === "PLAN" ? "header-title": "header-title-product"}
        gap-alt-8 fw500 is-flex is-align-items-center is-justify-content-center has-text-centered">
            {#if plan.type === "PRODUCT"}
                <i class="icon-tripod-number-one font-size-20"></i>
                {:else}
                    <i class="icon-tripod-bills font-size-20"></i>
            {/if}
            <span class="fw500">{metadata.lang?.on_plan_type[plan?.type ?? "PLAN"] ?? ""}</span>
        </h4>
    {/if}
</header-tag-promo>
<style>
@media only screen and (min-width:769px){
    header-tag-promo{
        position: relative;
        margin-bottom: 40px;
        display: block;
        width: 100%;
        z-index: 5;
    }
}
</style>